var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.63 24.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main_icons",
    "data-name": "Main icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12.31,15.14l9.19,9.19c.39.39,1.02.39,1.41,0l1.41-1.41c.39-.39.39-1.02,0-1.41l-9.19-9.19-2.83,2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.71.29L.29,1.71c-.39.39-.39,1.02,0,1.41l9.19,9.19,2.83-2.83L3.12.29c-.39-.39-1.02-.39-1.41,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.68,
    y: 3.95,
    width: 14,
    height: 4,
    rx: 1,
    ry: 1,
    transform: "translate(1.26 14.95) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.29,22.92l1.41,1.41c.39.39,1.02.39,1.41,0l9.19-9.19-2.83-2.83L.29,21.51c-.39.39-.39,1.02,0,1.41Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.35c160bf247aa2ab9804268c7ae64558.svg";
export { ForwardRef as ReactComponent };